import React from 'react'
import { Form, Input, Button, Icon, Row, Col, Divider, Select, Spin, Table, notification, Tooltip } from 'antd'
import debounce from 'lodash/debounce'
import API from '../../../services/API'

const { Option } = Select

// function hasErrors(fieldsError) {
//     return Object.keys(fieldsError).some(field => fieldsError[field]);
// }

const getRandomId = length => {
    let result = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const charactersLength = characters.length
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
}

class ReportInventoryForm extends React.Component {
    constructor(props) {
        super(props)
        this.getWarehouses = debounce(this.getWarehouses, 800)
        this.getProducts = debounce(this.getProducts, 800)
        this.getSubsidiaries = debounce(this.getSubsidiaries, 800)
    }

    state = {
        data: {},

        subsidiarie_id: {
            key: '',
            label: '',
        },
        warehouse_id: {
            key: '',
            label: '',
        },
        product_id: {
            key: '',
            label: '',
        },
        measure_unit_id: {
            key: '',
            label: '',
        },
        subsidiaries: {
            data: [],
            loading: false,
        },
        warehouses: {
            data: [],
            loading: false,
        },
        products: {
            data: [],
            loading: false,
        },
        measureUnits: {
            data: [],
            loading: false,
        },
        productsToWarehouse: [],
        productsToWarehouseIds: [],
        warehouseSearch: '',
        pagination: {},
        query:'',
    }

    componentDidMount() {
        // To disabled submit button at the beginning.
        if (this.props.fields && this.props.fields.name) {
            this.props.form.setFields({
                ...this.props.fields,
            })
            this.props.form.validateFields()
        }
        this.getAdittionalData()
    }

    getAdittionalData = () => {
        this.setState({
            measureUnits: {
                data: [],
                loading: false,
            },
        })
        this.getResourceTypeahead(
            'warehouses',
            `/api/warehouses?filter[subsidiary_id]=${this.state.subsidiarie_id.key}`,
            warehouse => ({
                text: `${warehouse.name}`,
                value: warehouse.id,
            })
        )
    }

    handleSubmit = e => {
        e.preventDefault()
        // validamos los valores y se los mandamops al padre para que los guarde
        // eslint-disable-next-line no-unused-vars
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const { getValues } = this.props
                if (getValues) {
                    getValues(this.state.productsToWarehouse)
                }
            }
        })
    }

    getResourceTypeahead = async (resource, uri, stateCallback) => {
        try {
            await this.setState({
                [resource]: {
                    // eslint-disable-next-line react/no-access-state-in-setstate
                    ...this.state[resource],
                    loading: true,
                },
            })
            const response = await API.get(uri)
            this.setState({
                [resource]: {
                    data: response.data.data.map(stateCallback),
                    loading: false,
                },
            })
        } catch (error) {
            this.setState({
                [resource]: {
                    data: [],
                    loading: false,
                },
            })
        }
    }

    getSubsidiaries = search => {
        this.getResourceTypeahead('subsidiaries', `/api/subsidiaries?filter[name]=${search}`, subsidiarie => ({
            text: `${subsidiarie.name}`,
            value: subsidiarie.id,
        }))
    }

    // eslint-disable-next-line consistent-return
    getWarehouses = search => {
        const { subsidiarie_id } = this.state
        if (subsidiarie_id.key === '') {
            notification.open({
                message: 'Primero debe seleccionar una sucursal.',
                // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            })
            return null
        }
        this.getResourceTypeahead(
            'warehouses',
            `/api/warehouses?filter[name]=${search}&filter[subsidiarie_id]=${subsidiarie_id.key}`,
            warehouse => ({
                text: `${warehouse.name}`,
                value: warehouse.id,
            })
        )
    }

    // eslint-disable-next-line consistent-return
    getProducts = search => {
        // eslint-disable-next-line no-unused-vars
        const { warehouse_id, productsToWarehouse } = this.state
        if (warehouse_id.key === '') {
            notification.open({
                message: 'Primero debe seleccionar una bodega.',
                // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            })
            return null
        }
        const query = ''
        /** Esto es para hacer que no se repitan los productos que ya ingresaste */
        // let productsIds = productsToWarehouse.map(g => g.product_id.key);
        // for (let index = 0; index < productsIds.length; index++) {
        //     const item = productsIds[index];
        //     query = `${query}&notIn[]=${item}`;
        // }
        this.getResourceTypeahead(
            'products',
            `/api/products?filter[name]=${search}&include[]=currency&include[]=brand&include[]=productType&include[]=measureUnit${query}`,
            product => ({
                text: `${product.name}`,
                value: product.id,
            })
        )
    }

    handleSelectChange = name => value => {
        this.setState({
            [name]: value,
            // data: {
            // 	...this.state.data,
            // 	[name]: value
            // }
        })
    }

    /* Lo dejamos preparado para agregar el measure_unit de forma de
    preview de lo que se ingresara no como manera funcional */
    handleProductChange = value => {
        this.setState({
            product_id: value,
            // measure_unit_id: {
            //     key: value.measure_unit.id,
            //     value: value.measure_unit.name,
            // }
        })
    }

    handleSelectSubsidiarieChange = value => {
        this.setState({
            subsidiarie_id: value,
            warehouses: {
                data: [],
                loading: false,
            },
            products: {
                data: [],
                loading: false,
            },
            warehouse_id: {
                key: '',
                label: '',
            },
            product_id: {
                key: '',
                label: '',
            },
            productsToWarehouse: [],
        })
        this.getResourceTypeahead('warehouses', `/api/warehouses?filter[subsidiary_id]=${value.key}`, warehouse => ({
            text: `${warehouse.name}`,
            value: warehouse.id,
        }))
    }

    handleSelectWarehouseChange = value => {
        //?filter[warehouse_id]=12&include=product,warehouse,subsidiary
        this.setState({
            warehouse_id: value,
            products: {
                data: [],
                loading: false,
            },
            query:'filter[warehouse_id]='+value+'&include=product,warehouse,subsidiary',
            productsToWarehouse: [],
        })
        this.getResourceTypeahead(
            'productsToWarehouse',
            `/api/inventory/product/search?filter[warehouse_id]=${value.key}&include=product,warehouse,subsidiary`,
            inventory => inventory
            /* inventory => ({
                text: `${inventory.product_id }--${ inventory.quantity}`,
                label: inventory.id,
            }), */
        )
    }

    // eslint-disable-next-line no-unused-vars
    getData = ({ page = 1, filters = null, sorter = null }) => {
        // eslint-disable-next-line no-unused-vars
        let query = ''
        if (filters) {
            const keys = Object.keys(filters)
            keys.forEach(k => {
                if (filters[k].length) {
                    query += `&filter[${k}]=${filters[k][0]}`
                }
            })
        }
        if (sorter && Object.keys(sorter).length) {
            const order = sorter.order === 'descend' ? '-' : ''
            query += `&sort=${order}${sorter.field}`
        }
        API.get(`/api/inventory/product/search?warehouse_id=${1}`)
            .then(response => {
                this.setState({
                    data: response.data.data,
                    pagination: {
                        // eslint-disable-next-line react/no-access-state-in-setstate
                        ...this.state.pagination,
                        total: response.data.total,
                    },
                    loading: false,
                })
            })
            .catch(() => {
                this.setState({
                    loading: false,
                })
            })
    }

    // eslint-disable-next-line consistent-return
    addToWarehouse = () => {
        const {
            subsidiarie_id,
            warehouse_id,
            product_id,
            // measure_unit_id,
            productsToWarehouse,
            productsToWarehouseIds,
        } = this.state
        const { getFieldValue } = this.props.form
        if (subsidiarie_id.key === '') {
            notification.error({
                message: 'Primero debe seleccionar una sucursal.',
                // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            })
            return null
        }

        const quantity = getFieldValue('quantity')

        const tempProductsToWarehouse = JSON.parse(JSON.stringify(productsToWarehouse))
        const tempProductsToWarehouseIds = JSON.parse(JSON.stringify(productsToWarehouseIds))
        tempProductsToWarehouse.push({
            uid: getRandomId(8),
            // subsidiarie_id,
            target_warehouse_id: warehouse_id,
            product_id,
            quantity,
        })
        tempProductsToWarehouseIds.push(product_id.key)
        this.setState({
            productsToWarehouse: tempProductsToWarehouse,
            productsToWarehouseIds: tempProductsToWarehouseIds,
            product_id: {
                key: '',
                label: '',
            },
            measure_unit_id: {
                key: '',
                label: '',
            },
        })
    }

    // eslint-disable-next-line no-unused-vars
    handleSearch = (selectedKeys, confirm, column) => {
        confirm()
    }

    handleReset = clearFilters => {
        clearFilters()
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        // render: text => (
        //     <Highlighter
        //         highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        //         searchWords={[this.state.searchText]}
        //         autoEscape
        //         textToHighlight={text.toString()}
        //     />
        // )
    })

    handleTableChange = (pagination, filters, sorter) => {
        // eslint-disable-next-line react/no-access-state-in-setstate
        const pager = { ...this.state.pagination }
        pager.current = pagination.current
        this.setState({
            pagination: pager,
            loading: true,
        })
        this.getData({
            page: pagination.current,
            filters,
            sorter,
        })
    }

    render() {
        // const {
        //     getFieldDecorator, getFieldsError, getFieldError, isFieldTouched,
        // } = this.props.form;

        // Only show error after a field is touched.
        // const quantityError = isFieldTouched('quantity') && getFieldError('quantity');
        // const nameError = isFieldTouched('name') && getFieldError('name');
        // const descriptionError = isFieldTouched('description') && getFieldError('address');
        // const filteredOptions = this.state.subsidiaries.data.filter(o => !selectedItems.includes(o));

        const columns = [
            {
                title: 'SKU',
                dataIndex: 'product.sku',
                key: 'product.sku',
            },
            {
                title: 'Barcode',
                dataIndex: 'product.barcode',
                key: 'product.barcode',
                // render: (label, record) => record.product_id,
            },
            {
                title: 'Producto',
                dataIndex: 'product.name',
                key: 'product.name',
                sorter: false,
                ...this.getColumnSearchProps('name'),
            },
            {
                title: 'Sucursal',
                dataIndex: 'subsidiary.name',
                key: 'subsidiary.name',
                sorter: false,
                ...this.getColumnSearchProps('subsidiary'),
            },
            {
                title: 'Cantidad',
                dataIndex: 'quantity',
                key: 'quantity',
                sorter: false,
            },
            {
                title: 'Perdidos',
                dataIndex: 'missing',
                key: 'missing',
                sorter: false,
            },
            {
                title: 'Dañados',
                dataIndex: 'damaged',
                key: 'damaged',
                sorter: false,
            },
            {
                title: 'Maximo',
                dataIndex: 'max',
                key: 'max',
                sorter: false,
            },
            {
                title: 'Minimo',
                dataIndex: 'min',
                key: 'min',
                sorter: false,
            },
        ]
        return (
            <React.Fragment>
                <div className="ant-header-button">
                    <Tooltip title="Generar hoja de calculo" placement="left">
                        <Button
                            style={{ marginRight: '10px' }}
                            type="primary"
                            shape="circle"
                            icon="download"
                            onClick={() =>
                                (window.location.href =
                                    '/api/excel?table=inventory&pagination=false&json=false&'+this.state.query)
                            }
                        />
                    </Tooltip>
                </div>
                <Form>
                    <Row gutter={16}>
                        <Col lg={8}>
                            <Form.Item label="Almacen">
                                <Select
                                    showSearch
                                    labelInValue
                                    value={this.state.warehouse_id}
                                    placeholder="Busca un almacen"
                                    notFoundContent={
                                        this.state.warehouses.loading ? <Spin size="small" /> : 'No hay resultados'
                                    }
                                    // disabled={this.state.productsToWarehouse.length !== 0}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    onChange={this.handleSelectWarehouseChange}
                                    style={{ width: '100%' }}
                                >
                                    {this.state.warehouses.data.map(d => (
                                        <Option key={d.value}>{d.text}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <br />
                    </Row>
                    <Row>
                        <Table
                            dataSource={this.state.productsToWarehouse.data}
                            columns={columns}
                            rowKey="uid"
                            onChange={this.handleTableChange}
                        />
                    </Row>
                </Form>
                <Divider />
            </React.Fragment>
        )
    }
}

const WrappedReportInventoryForm = Form.create({ name: 'InventoryEntryVerticalForm' })(ReportInventoryForm)
export default WrappedReportInventoryForm
